import { BANK, Banks } from '@celerofinancas/core-ts';

/**
 * Maps normalized 14-digit CNPJs to their corresponding BANK enum values.
 * Used to resolve bank logos via the core-ts Banks utility.
 */
const CNPJ_TO_BANK: Record<string, BANK> = {
  '00360305000104': BANK.cef,
  '00000000000191': BANK.bb,
  '60701190000104': BANK.itau,
  '60746948000112': BANK.bradesco,
  '90400888000142': BANK.santander,
  '18236120000158': BANK.nubank,
  '00416968000101': BANK.inter,
  '30306294000145': BANK.btg,
  '58160789000128': BANK.safra,
  '03795072000160': BANK.sicredi,
  '04891850000188': BANK.sicoob,
  '33264668000103': BANK.xp,
  '92894922000108': BANK.original,
  '16501555000157': BANK.stone,
  '62232889000190': BANK.daycoval,
  '71027866000134': BANK.bs2,
  '61186680000174': BANK.bmg,
};

/**
 * Normalizes a CNPJ string by removing non-digit characters and padding to 14 digits.
 *
 * @param cnpj - Raw CNPJ string in any format
 * @returns 14-digit zero-padded CNPJ string
 */
export function normalizeCnpj(cnpj: string): string {
  return cnpj.replace(/\D/g, '').padStart(14, '0');
}

/**
 * Resolves the logo URL for a bank identified by CNPJ using core-ts bank data.
 * Returns null when the CNPJ is unknown or the bank has no logo in core-ts.
 *
 * @param cnpj - Institution CNPJ (any format, including stripped leading zeros)
 * @param staticUrl - Base static assets URL from environment
 * @returns Logo image URL or null if not resolvable
 */
export function getBankLogoUrl(cnpj: string | null | undefined, staticUrl: string): string | null {
  if (!cnpj) return null;
  const bankCode = CNPJ_TO_BANK[normalizeCnpj(cnpj)];
  if (!bankCode) return null;
  const bank = Banks.get(bankCode);
  if (!bank?.has_logo) return null;
  return Banks.getLogoSrc(bankCode, staticUrl);
}
